export enum ENVIRONMENT_TYPE {
  LOCAL = 'LOCAL',
  TEST = 'TEST',
  STAGING = 'STAGING',
  PROD = 'PROD',
}

interface IEnvironment {
  name: string;
  domain?: string;

  tagColor: string;
  isForDebugging: boolean; //if TRUE, enables more logs, testing features etc for this environment. typically only on for LOCAL and TEST
  hotjarId?: number;
}

const ENVIRONMENT_LOOKUP: { [key in ENVIRONMENT_TYPE]: IEnvironment } = {
  [ENVIRONMENT_TYPE.LOCAL]: {
    name: 'Local',

    tagColor: '#ff4346',
    isForDebugging: true,
    // 'shortcutAccessCode' not needed
    // 'hotjarId' not needed
  },
  [ENVIRONMENT_TYPE.TEST]: {
    name: 'Test',
    domain: 'https://aotg.challenge.test.movember.com',
    
    tagColor: '#fffb00',
    isForDebugging: true,
    // 'hotjarId' not needed
  },
  [ENVIRONMENT_TYPE.STAGING]: {
    name: 'Staging',
    domain: 'https://aotg.challenge.staging.movember.com',
    
    tagColor: '#6dd911',
    isForDebugging: false,
    // 'hotjarId' not needed
  },
  [ENVIRONMENT_TYPE.PROD]: {
    name: 'Production',
    domain: 'https://aotg.challenge.movember.com',
    
    tagColor: '', //no displayed tag for prod
    isForDebugging: false,
    hotjarId: 2707121,
  },
}

export default {
  isEnvironment(type: ENVIRONMENT_TYPE): boolean {
    switch (type) {
      case ENVIRONMENT_TYPE.PROD:
        return window.location.origin === ENVIRONMENT_LOOKUP.PROD.domain;
      case ENVIRONMENT_TYPE.STAGING:
        return window.location.origin === ENVIRONMENT_LOOKUP.STAGING.domain;
      case ENVIRONMENT_TYPE.TEST:
        return window.location.origin === ENVIRONMENT_LOOKUP.TEST.domain;
      case ENVIRONMENT_TYPE.LOCAL:
        return window.location.origin.startsWith('http://localhost') 
          || window.location.origin.startsWith('https://localhost')
          || window.location.origin.includes('.dev.');
      default:
        throw new Error('Invalid environment type');
    }
  },

  getCurrentEnvironment(): IEnvironment {
    const currentEnvType = Object.keys(ENVIRONMENT_LOOKUP).find((type) => this.isEnvironment(type as ENVIRONMENT_TYPE));
    if (!currentEnvType) throw Error('Missing environment type');
  
    return ENVIRONMENT_LOOKUP[currentEnvType as ENVIRONMENT_TYPE];
  },
  
  getEnvironmentByType(type: ENVIRONMENT_TYPE): IEnvironment {
    return ENVIRONMENT_LOOKUP[type];
  },
}